module.exports = __webpack_public_path__ + "static/media/savadov-r-en.c70ef742.png";